import React from 'react';
import styled from 'styled-components';
import { Apartment } from '../types/Apartment';
import ApartmentCard from './ApartmentCard';

const ListContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  padding: 0;
  
  @media (max-width: 850px) {
    gap: 12px;
    padding: 0;
  }
  
  @media (min-width: 851px) {
    padding: 20px;
  }
`;

interface ApartmentListProps {
  apartments: Apartment[];
  selectedApartment: Apartment | null;
  onApartmentSelect: (apartment: Apartment) => void;
  onApartmentHover?: (apartment: Apartment | null) => void;
}

const ApartmentList: React.FC<ApartmentListProps> = ({
  apartments,
  selectedApartment,
  onApartmentSelect,
  onApartmentHover,
}) => {
  return (
    <ListContainer>
      {apartments.map((apartment) => (
        <div key={apartment.id}>
          <ApartmentCard
            apartment={apartment}
            isSelected={selectedApartment?.id === apartment.id}
            onClick={onApartmentSelect}
            onHover={onApartmentHover}
          />
        </div>
      ))}
    </ListContainer>
  );
};

export default ApartmentList;
